module.exports = __webpack_public_path__ + "img/37.c5c7f5d8.png";